import { render, staticRenderFns } from "./food-rank.vue?vue&type=template&id=6b28f804&scoped=true&"
import script from "./food-rank.vue?vue&type=script&lang=js&"
export * from "./food-rank.vue?vue&type=script&lang=js&"
import style0 from "./food-rank.vue?vue&type=style&index=0&id=6b28f804&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b28f804",
  null
  
)

export default component.exports